import React, { FC, ReactNode, useEffect, useState } from "react";
import { StayDataType } from "data/types";
import HeaderFilter from "./HeaderFilter";
import GuideOpenTripCard from "components/TripCard/GuideOpenTripCard";
import GuidePrivateTripCard from "components/TripCard/GuidePrivateTripCard";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "functions/redux/store";
import { getFeaturedTrip, getRecentOpenTrips } from "functions/redux/listing/homeAction";
import Skeleton from "react-loading-skeleton";
import NewTripCardRender from "components/TripCard/NewTripCard";
import Heading from "shared/Heading/Heading";
import i18n from "i18n/config";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useHistory } from "react-router";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import ncNanoId from "utils/ncNanoId";

// OTHER DEMO WILL PASS PROPS

//
export interface SectionGridFeaturePlacesProps {
  stayListings?: StayDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: any[];
}

const SectionGridFeaturePlaces: FC<SectionGridFeaturePlacesProps> = ({
  stayListings = [],
  gridClass = "",
  heading = "Featured trip",
  subHeading = "Open trip mendatang yang kamu bisa ikuti dengan banyak orang lainnya",
  headingIsCenter,
  tabs = [],
}) => {
  const dispatch = useDispatch();
  const { listing } = useSelector((state: RootStore) => state);
  const history = useHistory();

  useEffect(() => {
    if (listing.recentOpenTrips == null) {
      dispatch(getRecentOpenTrips());
    }
  }, [listing])

  const renderCard = (stay: any) => {
    return stay.isOpenTrip ? <GuideOpenTripCard data={stay} key={stay.id} /> : <GuidePrivateTripCard data={stay} key={stay.id} />;
  };

  return (
    listing.recentOpenTrips != null && listing.recentOpenTrips.length > 0 ?
      <>
        <BackgroundSection />
        <div className="nc-SectionGridFeaturePlaces relative">
          <div className="flex flex-col  relative">
            <div className="flex items-center justify-between">
              <Heading desc={i18n.t('recent_open_trip_desc')}>{i18n.t('recent_open_trip')}</Heading>
              <span className="hidden md:block flex-shrink-0">
                <ButtonSecondary onClick={() => history.push('/recent-open-trips?openTrip=1')} className="!leading-none">
                  <span>View all</span>
                  <i className="ml-3 las la-arrow-right text-xl"></i>
                </ButtonSecondary>
              </span>
            </div>
          </div>
          <div
            className={`grid gap-2 space-x-2 sm:grid-cols-2 lg:grid-cols-4 ${gridClass}`}
          >
            {listing.recentOpenTrips ? (listing.recentOpenTrips.map((stay: any) => (

              <NewTripCardRender key={ncNanoId()} item={stay} imgHeightClass='h-52 ' hideBadge={true} />


            )
            )) : <>
              <Skeleton height={350} />
              <Skeleton height={350} />
              <Skeleton height={350} />
              <Skeleton height={350} />
            </>}
          </div>
          <span className="block md:hidden flex-shrink-0">
            <ButtonSecondary onClick={() => history.push('/recent-open-trips?openTrip=1')} className="!leading-none w-full">
              <span className="my-2">View all</span>
            </ButtonSecondary>
          </span>
          {/* <div className="flex mt-16 justify-center items-center">
        <ButtonPrimary>Show me more</ButtonPrimary>
      </div> */}
        </div>
      </>

      : <></>
  );
};

export default SectionGridFeaturePlaces;
